module.exports = __webpack_public_path__ + "images/avatars/male/4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/4.svg
// module id = bPu8
// module chunks = 51